import { combineReducers } from 'redux';
import navigation from './navigation.reducer';
import settings from './settings.reducer';
import navbar from './navbar.reducer';
import message from './message.reducer';
var fuseReducers = combineReducers({
    navigation: navigation,
    settings: settings,
    navbar: navbar,
    message: message,
});
export default fuseReducers;



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/fuse/index.ts
// module id = 1163
// module chunks = 81